module.exports = __webpack_public_path__ + "static/media/5.41667af5.jpeg";